import React, { useEffect, useState } from "react"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Flatpickr from "react-flatpickr"
import TableComponent from "components/Table"
import { downloadReferFriendReport, getReferFriendReports } from "store/actions"
import referFriendListColumns from "./referFriendListColumns"
import { URL_PATHS } from "constants/index"

const ReferFriendReport = ({
  history,
  referFriendReport,
  getReferFriendReports,
  downloadReferFriendReport,
  match,
}) => {
  const { event_id } = match?.params
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "desc",
  })

  useEffect(() => {
    getReferFriendReports({
      event_id: event_id,
      page: 1,
      per_page: 20,
      o: "created_at",
      od: "desc",
    })
  }, [])

  const searchHanler = () => {
    setShowResetButton(true)
    getReferFriendReports({
      event_id: event_id,
      page: 1,
      per_page: 20,
      ...defaultOrder,
      start: startDate,
      end: endDate,
    })
  }

  const resetSearchHandler = () => {
    getReferFriendReports({
      event_id: event_id,
      page: 1,
      per_page: 20,
      ...defaultOrder,
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
  }

  const handlePageChange = page => {
    getReferFriendReports({
      event_id: event_id,
      per_page: 20,
      page: page,
      ...defaultOrder,
      start: startDate,
      end: endDate,
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getReferFriendReports({
      event_id: event_id,
      page: 1,
      per_page: 20,
      o: sortField,
      od: sortOrder,
      start: startDate,
      end: endDate,
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Refer a Friend" />
          <BreadcrumbTitle
            title={"Refer a Friend"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Refer a Friend" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Card>
            <CardBody>
              {referFriendReport?.data?.length > 0 && (
                <Row className="d-flex justify-content-end">
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Download Full Report"
                      onClick={() => {
                        downloadReferFriendReport({
                          event_id: event_id,
                          download: true,
                        })
                      }}
                    />
                  </Col>
                </Row>
              )}
              <Row className="justify-content-center">
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="Start Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={startDate}
                    onChange={(selectedDates, dateStr) => {
                      setStartDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="End Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={endDate}
                    onChange={(selectedDates, dateStr) => {
                      setEndDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <SaveButton
                    type="button"
                    content="Filter"
                    onClick={searchHanler}
                  />
                </Col>
                {showResetButton && (
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Reset"
                      color="light"
                      onClick={resetSearchHandler}
                    />
                  </Col>
                )}
              </Row>
              <Row className="mt-4">
                <Col>
                  <TableComponent
                    columns={referFriendListColumns()}
                    data={referFriendReport?.data}
                    paginationData={{
                      current_page: referFriendReport?.current_page,
                      last_page: referFriendReport?.last_page,
                      total_items: referFriendReport?.total,
                      items_per_page: referFriendReport?.per_page,
                      from: referFriendReport?.from,
                      to: referFriendReport?.to,
                      first_page: 1,
                    }}
                    onPageChange={handlePageChange}
                    onTableSort={handleSort}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  referFriendReport: state.ReferFriend.referFriendReport,
})

const mapDispatchToProps = dispatch => ({
  getReferFriendReports: values => dispatch(getReferFriendReports(values)),
  downloadReferFriendReport: values =>
    dispatch(downloadReferFriendReport(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReferFriendReport))
